import { useEffect } from 'react';
import { Button } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { PasswordRules } from '@/features/dashboard-users/components/changePassword/PasswordRules';
import { ChangePasswordForm } from '@/features/dashboard-users/components/changePassword/ChangePasswordForm';
import use2FAAuthentication from '@/features/dashboard-users/hooks/changePassword/use2FAAuthentication';
import { useChangeOwnPassword } from '@/features/dashboard-users/hooks/changePassword/useChangeOwnPassword';

export function DefineOwnPassword() {
  const { t } = useTranslation();

  const {
    currentPasswordWatch,
    newPasswordWatch,
    confirmNewPasswordWatch,
    isNewAndConfirmPasswordTheSame,
    isFormValid,
    isCurrentSupportUserLoading,
    isCaracterNumberValid,
    isPasswordContainsLowercase,
    isPasswordContainsUppercase,
    isPasswordContainsSpecialChar,
    isPasswordContainsNumber,
    isNewPasswordDifferentFromCurrent,
    handleInputChange,
    onSavePassword,
    updatePassword,
  } = useChangeOwnPassword();

  const { authenticate2FA, credentials, setCredentials } = use2FAAuthentication();

  useEffect(() => {
    !!credentials && updatePassword(credentials);
    setCredentials('');
  }, [credentials, setCredentials, updatePassword]);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <p className="typo-h2-bold text-secondary">{t('pages.auth.changePassword.defineNewPassword.title')}</p>
        <p className="typo-body-regular-paragraphLarge">
          {t('pages.auth.changePassword.defineNewPassword.description')}
        </p>
      </div>
      <ChangePasswordForm
        currentPasswordWatch={currentPasswordWatch}
        newPasswordWatch={newPasswordWatch}
        confirmNewPasswordWatch={confirmNewPasswordWatch}
        isNewAndConfirmPasswordTheSame={isNewAndConfirmPasswordTheSame}
        isNewPasswordDifferentFromCurrent={isNewPasswordDifferentFromCurrent}
        handleInputChange={handleInputChange}
      />
      <PasswordRules
        isCaracterNumberValid={isCaracterNumberValid}
        isPasswordContainsLowercase={isPasswordContainsLowercase}
        isPasswordContainsUppercase={isPasswordContainsUppercase}
        isPasswordContainsSpecialChar={isPasswordContainsSpecialChar}
        isPasswordContainsNumber={isPasswordContainsNumber}
      />

      <Button
        type="submit"
        size="m"
        testId="button-save-change-password"
        disabled={!isFormValid}
        onClick={() => {
          onSavePassword((challenge) => authenticate2FA(challenge));
        }}
        isLoading={isCurrentSupportUserLoading}
      >
        {t('pages.auth.changePassword.title')}
      </Button>
    </div>
  );
}
